import type {GetVendorProListResponse} from './types';

import {createSlice} from '@reduxjs/toolkit';

import {vendorProBuilder} from './reducer';

export type VendorProPlanItem = {
  polygon_id: number;
  polygon_title: string;
  cost_per_order: number;
  cells: string[];
};

export type VendorProState = {
  loading: boolean;
  list: GetVendorProListResponse | null;
  details: {
    id: number;
    start_date: string;
    end_date: string;
    state: string;
  } | null;
  detailLoading: boolean;
  plans: {
    latitude: number;
    longitude: number;
    items: VendorProPlanItem[];
  } | null;
  plansLoading: boolean;
  create: {
    loading: boolean;
  };
  confirm: {
    loading: boolean;
    result: {state: string; start_date: string} | null;
  };
  remove: {
    loading: boolean;
  };
  done: {
    loading: boolean;
  };
  pause: {
    loading: boolean;
  };
};

const initialState: any = {
  loading: false,
  list: null,
  details: null,
  detailLoading: false,
  plans: null,
  plansLoading: false,
  create: {
    loading: false
  },
  confirm: {
    loading: false,
    result: null
  },
  remove: {
    loading: false
  },
  done: {
    loading: false
  },
  pause: {
    loading: false
  }
};

export const vendorProSlicer = createSlice({
  name: 'vendorPro',
  initialState,
  reducers: {},
  extraReducers: vendorProBuilder
});

export default vendorProSlicer.reducer;
